var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d-flex flex-row" },
    [
      _vm.picture
        ? _c("ob1-picture", { attrs: { visual: _vm.picture } })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pl-1" },
        [
          _c("div", { staticClass: "font-weight-bold" }, [
            _vm._v("\n            " + _vm._s(_vm.title) + "\n        "),
          ]),
          _vm._v(" "),
          _c("p", {
            staticClass: "mb-0",
            domProps: { innerHTML: _vm._s(_vm.condition) },
          }),
          _vm._v(" "),
          _c("ob1-liens", {
            attrs: {
              href: _vm.formUrl,
              text: _vm.conditionLabel,
              "is-link": "",
              "is-mini": "",
              "with-arrow": "",
              target: "_blank",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }